import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProjectStatusGraphic from '../../../graphics/ProjectStatusGraphic';
import moment from 'moment-timezone';

import './TableRowCell.scss';
import { LoadingDots } from '../../../LoadingDots';
import optionsIcon from '../../../../assets/images/more-dots-vertical.svg';
import trashIcon from '../../../../assets/images/trash.svg';
import _ from 'lodash';

export class TableRowCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.handleOptions = this.handleOptions.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  handleGenericCell() {
    const { cellType, selectedItem } = this.props;

    let dataToRender = selectedItem[cellType]; 
    return (
        <div className="cell-text">{ dataToRender }</div>
    );
  }

  handleReferenceDocCell() {
    const { cellType, selectedItem } = this.props;
    let dataToRender = selectedItem[cellType];

    switch (cellType) {
    case 'extension':
      const fileParts = selectedItem.name.split('.');
      dataToRender = fileParts.length > 0 ? fileParts[fileParts.length - 1].toUpperCase() : '';
      break;
    
    case 'full_name':
      dataToRender = (!selectedItem.user || selectedItem.user.id == 1) ? 'Unknown' :
          ((selectedItem.user.last_name ? selectedItem.user.last_name.trim() + ', ' : '') + selectedItem.user.first_name);
      break;
          
    case 'date_time':
      const { createDate, createTime } = this.createDateAndTime(selectedItem['created_at']);
      return (
          <div className="cell-text"><p>{createDate}</p><p>{createTime}</p></div>
        );
      
    case 'markets':
      dataToRender = selectedItem.markets ? selectedItem.markets : 'N/A';
      break;
      
    default:
      break;
    }
  
    return (
      <div className="cell-text">{dataToRender}</div>
    );
  }

  handleAttachmentCell() {
    const { cellType, selectedItem } = this.props;
  
    let dataToRender = selectedItem[cellType];
  
    switch (cellType) {
    case 'name':
      dataToRender = selectedItem.name;
      break;
        
    case 'type':
      const fileParts = selectedItem.name.split('.');
      dataToRender = fileParts.length > 0 ? fileParts[fileParts.length - 1].toUpperCase() : '';
      break;
      
    case 'user':
      dataToRender = (!selectedItem.user || selectedItem.user.id == 1) ? 'Unknown' :
          ((selectedItem.user.last_name ? selectedItem.user.last_name.trim() + ', ' : '') + selectedItem.user.first_name);
      break;
        
    case 'created_at':
      const { createDate, createTime } = this.createDateAndTime(selectedItem['created_at']);
      return (
          <div className="cell-text"><p>{createTime + ' ' + createDate}</p></div>
        );
    default:
      break;
    }
  
    return (
      <div className="cell-text">{dataToRender}</div>
    );
  }

  handleUserCell() {
    const { selectedItem, cellType } = this.props;

    let dataToRender;
    switch (cellType) {
    case 'company_name':
      dataToRender = selectedItem.companies && selectedItem.companies[0] ? selectedItem.companies[0].name : '-';
      break;
    case 'projects':
      dataToRender = selectedItem.active_projects_count || 0;
      break;
    case 'active_total_tasks':
      let activeTasks = selectedItem.active_tasks_count || 0;
      let totalTasks = selectedItem.total_tasks_count || 0;
      dataToRender = `${activeTasks} | ${totalTasks}`;
      break;
    case 'role':
      dataToRender = selectedItem.role ? selectedItem.role.description : '';
      break;
    case 'markets':
      let marketsToRender = selectedItem.markets;
      if (this.props.isVendorUser) {
        marketsToRender = !selectedItem.market_vendor_users ? selectedItem.vendor_markets : selectedItem.market_vendor_users.filter(mvu => {
          return mvu.market.company_id == this.props.currentCompany.id;
        }).map(mvu => { return mvu.market; });
      }
      if (marketsToRender) {
        let mk = marketsToRender.map((market) => {
          return market.code;
        });
        mk.sort((m1, m2) => {return m1 < m2 ? -1 : (m1 > m2 ? 1 : 0);});
        dataToRender = mk.join(', ');
      }
      break;
    default:
      dataToRender = selectedItem[cellType];
      break;
    }
   
    return (
      <div className='cell'>
        <div className="cell-text">{ dataToRender }</div>
      </div>
    );
  }

  handleTeamCell() {
    const { selectedItem, cellType } = this.props;

    let dataToRender;
    switch (cellType) {
    case 'name':
      dataToRender = selectedItem.name;
      break;
    case 'lead_user':
      dataToRender = selectedItem.lead_user ? (selectedItem.lead_user.last_name ?
          selectedItem.lead_user.last_name.trim() + ', ' : '')
          + selectedItem.lead_user.first_name : 'None';
      break;
    case 'projects_active':
      dataToRender = selectedItem.projects_active;
      break;
    case 'members':
      dataToRender = selectedItem.users && selectedItem.users.length;
      break;
    case 'markets':
      const marketsToRender = selectedItem.markets;
      if (marketsToRender) {
        let mk = marketsToRender.map((market) => {
          return market.code;
        });
        mk.sort((m1, m2) => { return m1 < m2 ? -1 : (m1 > m2 ? 1 : 0); });
        dataToRender = mk.join(', ');
      }
      break;
    default:
      dataToRender = selectedItem[cellType];
      break;
    }
   
    return (
      <div className='cell'>
        <div className='cell-text'>{ dataToRender }</div>
      </div>
    );
  }

  handleProjectCell() {
    const { selectedItem, cellType } = this.props;
    let location = selectedItem.location;
    let dataToRender = selectedItem[cellType];
    if (cellType == 'status') {
      return (
        <ProjectStatusGraphic project={selectedItem} accent={this.props.accent} />
      );
    }

    if (cellType == 'address') {
      return (
        <div className='cell'>
          <div className='cell-text cell-text__address'>{location ? location.address : ''}</div>
          <div className='cell-text cell-text__address'>{location ? `${location.city ? location.city + ', ' : ''} ${location.state} ${location.zip}` : ''}</div>
        </div>
      );
    }

    if (cellType == 'project_name') { 
      dataToRender = selectedItem ? selectedItem.name : 'No Project Name';
    }
    if (cellType == 'location_id') { dataToRender = location ? location.guid : ''; }
    if (cellType == 'site_name') { dataToRender = location ? location.name : ''; }
    if (cellType == 'project_type') { 
      dataToRender = selectedItem.project_type ? selectedItem.project_type.name : 'No Project Type';
    }
    if (cellType == 'project_manager') {
      if (selectedItem.project_manager) {
        const { last_name, first_name } = selectedItem.project_manager;
        dataToRender = last_name && first_name ? last_name + ', ' + first_name : last_name ? last_name : first_name;
      }
      else {
        dataToRender = 'No Project Manager';
      }
    }

    if (cellType == 'created_at') {
      dataToRender = this.createDateAndTime(selectedItem['created_at']).createDate;
    }
    
    return (
      <div className='cell'>
        <div className={`cell-text cell-text__${cellType}`}>{dataToRender}</div>
      </div>
    );
  }

  handleActivityCell() {
    const { selectedItem, cellType } = this.props;

    let dataToRender = selectedItem[cellType];
    let cellTextClass = 'activity-log-cell-text';

    if (cellType == 'name') { 
      dataToRender = selectedItem.activity ? selectedItem.activity.name : '';
      cellTextClass += ' first';
    }

    if (cellType == 'sub_type') {
      dataToRender = selectedItem.activity_sub_type ? selectedItem.activity_sub_type.name : '';
    }

    if (cellType == 'date_time') {
      const { createDate, createTime } = this.createDateAndTime(selectedItem['created_at']);
      return (
        <div className='cell'>            
          <div className={cellTextClass}><p>{createDate}</p><p>{createTime}</p></div>
        </div>
      );
    }

    if (cellType == 'company_name' && selectedItem.user_who_performed_action) {
      let company;
      if (selectedItem.user_who_performed_action.companies) {
        company = selectedItem.user_who_performed_action.companies[0];
      }
      dataToRender = company ? company.name : '';
    }

    if (cellType == 'description') { dataToRender = selectedItem.body; }

    return (
      <div className='cell'>            
        <div className={cellTextClass}>{ dataToRender }</div>
      </div>
    );
  }

  handleInventoryCell() {
    const { selectedItem, cellType } = this.props;

    let dataToRender = selectedItem[cellType];

    if (cellType == 'created_at') {
      const { createDate, createTime } = this.createDateAndTime(selectedItem['created_at']);
      return (
        <div className='cell'>            
          <div className={'cell-text'}><p>{createDate}</p><p>{createTime}</p></div>
        </div>
      );
    }
    else if (cellType == 'tasks') {
      dataToRender = selectedItem[cellType].reduce((acc, task) => {
        return acc + (acc.length ? ', ' : '') + (_.isString(task) ? task : task.name);
      }, '');
    }
    else if (cellType == 'name') {
      dataToRender = selectedItem.inventory ? selectedItem.inventory.name : 'n/a';
    }
    else if (cellType == 'user') {
      const u = selectedItem.user;
      if (!u) dataToRender = 'n/a';
      else if (u.first_name != null && u.last_name != null) dataToRender = (u.first_name + ' ' + u.last_name).trim();
      else dataToRender = u.name || 'n/a';
    }

    return (
      <div className='cell'>            
        <div className={'cell-text'}>{ dataToRender }</div>
      </div>
    );
  }

  handleCloseoutCell() {
    const { selectedItem, cellType } = this.props;

    let dataToRender = selectedItem[cellType];

    if (cellType == 'project_type_name') {
      dataToRender = selectedItem.project_type_name ? selectedItem.project_type_name : 'No Project Type';
    }

    if (cellType == 'created_at') {
      const { createDate, createTime } = this.createDateAndTime(selectedItem['created_at']);
      const dateText = selectedItem.status == 1 ? 'Generating Now' : createTime + ' ' + createDate;
      return (
        <div className='cell'>
          { selectedItem.status == 1 && <LoadingDots/> }
          <div className={'cell-text'}><p>{dateText}</p></div>
        </div>
      );
    }

    if (cellType == 'status') {
      if(selectedItem.status == 0){
        dataToRender = 'Completed';
      }
      else if(selectedItem.status == 1){
        dataToRender = 'In Progress';
      }
      else {
        dataToRender = 'Not Started';
      }
    }

    return (
      <div className="cell-text">{dataToRender}</div>
    );
  }

  createDateAndTime(selectedTime) {
    const timeZone = moment.tz.guess();
    let createDate = moment.tz(selectedTime, timeZone).format('MM/DD/YY');
    let createTime = moment.tz(selectedTime, timeZone).format('h:mm A z');

    return { createDate, createTime };
  }

  handleOptions(e) {
    const { optionsHandler, selectedItem } = this.props;
    if (optionsHandler) {
      e.stopPropagation();
      optionsHandler(e, selectedItem);
    }
  }

  handleDelete(e){
    const { deleteHandler, selectedItem } = this.props;
    if (deleteHandler) {
      e.stopPropagation();
      deleteHandler(e, selectedItem);
    }
  }

  render() {
    const { cellType, type } = this.props;

    let typeToRender;
    let rowClass = cellType ? (' ' + type + '-' + cellType) : '';

    if (cellType == 'options') {
      return (
        <div className="users-options" onClick={this.handleOptions}>
          <img src={optionsIcon} alt="Options"/>
        </div>
      );
    }
    else if (cellType == 'delete') {
      return (
        <div className="delete-option" onClick={this.handleDelete}>
          <img src={trashIcon} alt="Options"/>
        </div>
      );
    }
    else if (type == 'reference-documents') { typeToRender = this.handleReferenceDocCell(); }
    else if (type == 'user' || type == 'users') { typeToRender = this.handleUserCell(); }
    else if (type == 'activity-log') { typeToRender = this.handleActivityCell(); }
    else if (type == 'project-report') { typeToRender = this.handleProjectCell(); }
    else if (type == 'inventory') {typeToRender = this.handleInventoryCell(); }
    else if (type == 'closeout') {typeToRender = this.handleCloseoutCell();}
    else if (type == 'team') {typeToRender = this.handleTeamCell();}
    else if (type == 'attachment') {typeToRender = this.handleAttachmentCell();}
    else typeToRender = this.handleGenericCell();
    
    return (
      <div className={ 'cell' + rowClass }>
        { typeToRender }
      </div>
    );

  }

}

export default TableRowCell;

TableRowCell.propTypes = {
  type: PropTypes.string.isRequired,
  cellType: PropTypes.string.isRequired,
  selectedItem: PropTypes.object.isRequired,
  accent: PropTypes.string,
  optionsHandler: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Table/TableRow/TableRowCell/index.js